import "core-js/modules/es.array.concat";
// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export default (function () {
  return {
    path: '/studios-v2/:venueAlias',
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('features/InventoryDetail/InventoryDetailContainer').InventoryDetailContainer
        });
      }, 'venue-detail');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: 'reviews',
          component: require('features/InventoryDetail/VenueReviews').VenueReviews
        }, {
          path: ':scheduleId(\\d+)',
          onEnter: function onEnter(_ref, replace, cb) {
            var params = _ref.params;
            return cb(replace({
              pathname: "/classes/".concat(params.venueAlias, "/").concat(params.classAlias, "/").concat(params.scheduleId),
              state: {
                status: 301
              }
            }));
          }
        }]);
      }, 'venue-detail');
    }
  };
});